import { useCallback, useMemo } from 'react'

import { useExecuteCommandMutation } from '@redux/api'

import { ExecuteCommandPayload } from '@types'

export const useExecuteCommandMutationWithFixedKey = (fixedCacheKey: string) => {
  const stableFixedCacheKey = useMemo(() => fixedCacheKey, [fixedCacheKey])

  const [triggerExecuteCommand, executeCommandResult] = useExecuteCommandMutation({
    fixedCacheKey: stableFixedCacheKey,
  })

  const trigger = useCallback(
    (payload: ExecuteCommandPayload) => triggerExecuteCommand(payload),
    [triggerExecuteCommand]
  )

  return [trigger, executeCommandResult] as const
}
